export const svgIcons = {
    arrow: (
        // eslint-disable-next-line react/react-in-jsx-scope
        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* eslint-disable-next-line react/react-in-jsx-scope */}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.999821 -7.9919e-09C0.802064 4.19364e-05 0.60876 0.0587153 0.444343 0.168603C0.279928 0.278491 0.151784 0.434659 0.0761104 0.617364C0.000438279 0.80007 -0.0193657 1.00111 0.0192027 1.19507C0.0577722 1.38903 0.15298 1.5672 0.292795 1.70705L5.29297 6.7072C5.48051 6.89468 5.73483 7 6 7C6.26517 7 6.51949 6.89468 6.70702 6.7072L11.7072 1.70705C11.847 1.5672 11.9422 1.38903 11.9808 1.19507C12.0194 1.00111 11.9996 0.800071 11.9239 0.617365C11.8482 0.43466 11.7201 0.278492 11.5557 0.168604C11.3912 0.0587162 11.1979 4.28452e-05 11.0002 8.66267e-07L0.999821 -7.9919e-09Z"
                fill="#222222"
            />
        </svg>
    ),
    copy: (
        // eslint-disable-next-line react/react-in-jsx-scope
        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* eslint-disable-next-line react/react-in-jsx-scope */}
            <path d="M4 16V0H12.5L17 4.5V16H4ZM12 5V1H5V15H16V5H12ZM0 20V6H1V19H11V20H0Z" fill="#9A9A9A" />
        </svg>
    ),
}
